import Vue from "vue";
import Component from "vue-class-component";
import { MethodService } from "@/utils/serviceModel";
import { Watch } from "vue-property-decorator";
import GhBase from "@/components/ghBase";
import StructureNavigation from "@/businessComponents/mdl/structureNavigation/structureNavigation";
import StructureSelector from "@/businessComponents/mdl/structureSelector/structureSelector";

@Component({
  components: {
    StructureNavigation,
    StructureSelector
  }
})
export default class PersonService extends GhBase {
  protected statistic: IndexObject | any = {};

  protected structureSource: IndexObject[] | any = [];

  private personCount(struId: string) {
    if (this.statistic) {
      let count = this.statistic[struId];
      if (count) {
        return count.value;
      }
    }
    return 0;
  }

  @Watch("structureSource")
  protected async queryStatistic() {
    if (!this.structureSource) {
      return;
    }

    try {
      await this.svStatistic.invokeAsyn();
      if (this.svStatistic.isSuccess) {
        this.statistic = this.svStatistic.data;
      } else {
        this.statistic = null;
      }
    } catch (error) {
      this.statistic = null;
    } finally {
    }
  }

  protected async changePost(ids: string[], newPosId: string, newPosName) {
    let args = {
      ["ids"]: ids,
      structure_id: newPosId,
      structure_name: newPosName
    };
    await this.svChangePost.invokeAsyn(args);
  }

  created() {
    if (this.innerReq) {
      this.svStatistic = this.$createService(
        this.innerReq.moduleName,
        this.innerReq.className,
        this.innerReq.method
      );
      this.svChangePost = this.$createService(
        this.innerReq.moduleName,
        this.innerReq.className,
        "change_post"
      );
    }
  }
  private svStatistic: MethodService;
  private svChangePost: MethodService;

  private innerReq: IRequestInfo = {
    moduleName: "mes.business.mdl.person.service",
    className: "PersonService",
    method: "statistic_count",
    args: {}
  };
}
